<template>
  <div ref="bar" :style="{ width, height }" ></div>
</template>

<script>
import echarts from "echarts";

export default {
  name: 'EchartsBar',
  props: {
    status: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    width: {
      type: String,
      default: () => {
        return '100%'
      },
    },
    height: {
      type: String,
      default: () => {
        return '100%'
      },
    },
    autoResize: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    grid: {
      type: Object,
      default: () => {
        return {
          top: "20%",
          left: "10%",
          bottom:"15%",
          right:"5%"
        }
      }
    },
    legendData: {
      type: Array,
      default: () => {
        return []
      }
    },
    legendConfig: {
      type: Object,
      default: () => {
        return {
          top: "5%",
          textStyle: {
            color: "#ffffff",
          },
        }
      }
    },
    xAxis: {
      type: Object,
      default: () => {
        return {
          data: ['1月', '2月', '3月', '4月', '5月', '6月'],
          axisLine: {
            //隐藏X轴轴线
            show: false,
          },
          axisTick: {
            //隐藏X轴刻度
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              //X轴文字颜色
              color: "#ebf8ac",
            },
          },
        }
      }
    },
    yAxisConfig: {
      type: Array,
      default: () => {
        return [
          {
            type: 'value',
            nameTextStyle: {
              color: "#ebf8ac",
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ebf8ac",
              },
            },
            splitLine: {
              // show: true,
              lineStyle: {
                color: "#40A1EA", //网格横线颜色
              },
            },
          }
        ];
      },
    },
    yAxisSeries: {
      type: Array,
      default: () => {
        return [
          {
            name: '肉类',
            type: "bar",
            barWidth: 10,
            data: [44.0, 41.9, 37.0, 63.2, 45.6, 76.7],
            // 柱状样式
            color: {
              type: 'linear',
              x: 0, //右
              y: 0, //下
              x2: 0, //左
              y2: 1, //上
              colorStops: [
                {
                  offset: 0,
                  color: '#6f3d9e' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#3637a3' // 100% 处的颜色
                }
              ]
            },
          },
        ];
      },
    },
  },
  data() {
    return {
      // width: this.width,
    }
  },
  created() {

  },
  mounted() {
    this.init()
    if (this.autoResize) {
      window.addEventListener('resize', this.handlerResize)
    }
  },
  methods: {
    init() {
      this.bar = echarts.init(this.$refs.bar)
      this.bar.setOption(this.handlerSetOptions())
    },
    handlerClear() {
      this.bar && this.bar.clear()
    },
    handlerResize() {
      this.bar.resize()
    },
    handlerSetOptions() {
      const optionData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        grid: this.grid,
        legend: {
          data: this.legendData,
          ...this.legendConfig
        },
        xAxis: this.xAxis,
        yAxis: this.yAxisConfig,
        series: this.yAxisSeries
      }
      return optionData;
    },
    handlerRefresh () {
      this.handlerClear()
      this.bar.setOption(this.handlerSetOptions())
    }
  },
  watch:{
    status () {
      this.handlerRefresh()
    }
  },
  beforeDestroy () {
    this.handlerClear()
  },
}
</script>
<style>
#paging .el-input__inner {
  margin: 0 !important
}
</style>